import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const Contact = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Contact Us
                                            </h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Contact Us
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p>
                                                    <strong>Karamchand Memorial School</strong>
                                                    <br />
                                                    Vill &amp; Teh: Bass, District: Hisar, Haryana<br />
                                                    Mob. 857 000 3331, 857 000 3338<br />
                                                    <a href="mailto:karamchandmemorialschool@gmail.com">
                                                        karamchandmemorialschool@gmail.com
                                                    </a>
                                                    <div className="mt-4 mt-md-5">
                                                        <iframe
                                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3485.983323934914!2d76.20042221509334!3d29.106173682233276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391213b265680209%3A0x9eba238e70fb0310!2sKaramchand%20Memorial%20School%20(KCMS)!5e0!3m2!1sen!2sin!4v1679038588122!5m2!1sen!2sin"
                                                            width="100%" height="500" style={{ border: 0 }} allowfullscreen="" loading="lazy"
                                                            referrerpolicy="no-referrer-when-downgrade">
                                                        </iframe>
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default Contact;